import React, { useState } from 'react';
import { Button, Col, Container, Row, TabContent, TabPane } from 'reactstrap';
import AdminDashboardComponents from '../../Components/AdminComponents/AdminDashboardComponents';
import GetAllProjectsComponents from '../../Components/AdminComponents/GetAllProjectsComponents';
import AllUserComponents from '../../Components/AdminComponents/AllUserComponents';
import Activitylog from '../../Components/AdminComponents/Activitylog';
import ResetPassword from '../../Components/AdminComponents/ResetPassword';
import Projectlist from '../../Components/AdminComponents/Projectlist';
import TeamLeadview from '../../Components/AdminComponents/TeamLeadview';
import ProjectManagerView from '../../Components/AdminComponents/ProjectManagerView';
import ClientProjectsWithTasks from '../../Components/Client/ClientProjectsWithTasks';

const AdminDashboard: React.FC = () => {
  const refresh = false;
  const [activeTab, setActiveTab] = useState('TeamLead');

  const toggleTab = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const navButton = [
    { label: "Dashboard", tab: "Dashboard" },
    { label: "Project Manager View", tab: "ProjectManager" },
    { label: "TeamLead View", tab: "TeamLead" },
    { label: "Client View", tab: "Projects" },
    { label: "Users", tab: "Users" },
    { label: "Reset Password", tab: "CreateUser" }
  ];

  const tabContents = [
    { id: "Dashboard", component: <AdminDashboardComponents /> },
    { id: "Users", component: <AllUserComponents refreshTrigger={refresh} /> },
    { id: "Projects", component: <ClientProjectsWithTasks  /> },
    { id: "CreateUser", component: <ResetPassword /> },
    { id: "ProjectManager", component: <ProjectManagerView refreshTrigger={false} /> },
    { id: "TeamLead", component: <TeamLeadview /> },
    { id: "ActivityLog", component: <Activitylog refreshTrigger={refresh} /> }
  ];



  return (
    <div className="Admindb" style={{ padding: '20px' }}>
      <Row className="mt-4" >
        <Col sm={12} className="d-flex flex-wrap justify-content-center gap-2 mb-3">
          {navButton.map((item, index) => (
            <Button
              key={index}
              color="primary"
              outline
              className="tab-btn"
              onClick={() => toggleTab(item.tab)}
            >
              {item.label}
            </Button>
          ))}
        </Col>
      </Row>



      <Row>
        {activeTab === "Dashboard" && (
          <Col sm={12} md={2} lg={2}>
            <Projectlist />
          </Col>
        )}

        <Col sm={12} md={activeTab === "Dashboard" ? 10 : 12} lg={activeTab === "Dashboard" ? 10 : 12}>
          <TabContent activeTab={activeTab}>
            {tabContents.map((tab, index) => (
              <TabPane key={index} tabId={tab.id}>
                {tab.component}
              </TabPane>
            ))}
          </TabContent>
        </Col>
      </Row>

    </div>
  );
};

export default AdminDashboard;
